require('./brokerWarrantsAdvancedSellStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @constants
const {
	SECOND_STEP,
	BROKER_STOCKS_ADVANCED_BUY_FIELDS_MAXLENGHT_LIMIT,
    BROKER_STOCKS_ADVANCED_BUY_FIELDS_AMOUNT_MAXLENGHT_LIMIT,
	BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER
} = require('constants/index');
const nonNumericRegex = /[^\d]/g;

// @ commons
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKMessage } = require('commonsComponents/OKMessage');
const { AmountInput } = require('commonsComponents/amountInput');

// @ actions
const BrokerWarrantsAdvancedSellActions = require('actions/brokerWarrantsAdvancedSell');

class BrokerWarrantsAdvancedSellStep2 extends React.Component {

    constructor(props) {
        super(props);
        this.handleTitleQuantityChanged = this.handleTitleQuantityChanged.bind(this);
        this.onLimitedValueChanged = this.onLimitedValueChanged.bind(this);
    }

    onLimitedValueChanged(value) {
        this.props.limitedValueChanged(value);
    }

    buildStocksContractDropdownOptions() {
        const { immStocksContract } = this.props;

        const processedStocksContract = immStocksContract.map((entry, index) => {
            const newEntry = entry.merge({ value: index });
            return newEntry;
        });

        return processedStocksContract.toJS();
    }

    buildStocksContractDropdownPlaceholder() {
        return (
            <div>
                <FormattedText value="" />
            </div>
        );
    }

    handleTitleQuantityChanged(event) {
        this.props.titleQuantityChanged(event.target.value.replace(nonNumericRegex, "").trim());
    }

    render(){
        const {immBrokerWarrantsAdvancedSell, stockContractChanged} = this.props;
        const steps = immBrokerWarrantsAdvancedSell.get('steps');
        const step2 = steps.get(SECOND_STEP);
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const stocksContractPlaceholder = formatText('broker-stocksContractDropdownPlaceholder');
        const stocksContractSelectedValue = step2.get('selectedOptionValue');
        const titleQuantity = step2.get('titleQuantity');
        const limitPrice = step2.get('limitPrice');

        return (
            <div className="warrants-advanced-buy-step2">
                <header className="warrants-advanced-buy-step2__header">
                    <h2 className="warrants-advanced-buy-step2__header-title">
                        <FormattedText value="broker-stocksSellStep1HeaderTitle" />
                    </h2>
                </header>
                <FormattedText value="broker-stocksAdvancedBuyStep2InstructionsText" className="warrants-advanced-buy-step2__info-text" />
                <div className="warrants-advanced-sell-step2__dropdown">
                    <StocksContractDropdown
                        label="broker-warrantsAdvancedSellDropdownTitle"
                        onStockContractChange={stockContractChanged}
                        options={stocksContractDropdownOptions}
                        selectedValue={stocksContractSelectedValue}
                        placeholder={stocksContractPlaceholder}
                        modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER}
                    />
                </div>
                <div className="warrants-advanced-buy-step2__text-input-wrapper warrants-advanced-buy-step2__text-input-wrapper--no-left warrants-advanced-buy-step2__group-div ">
                    <InputSafe
                        label={formatText('broker-warrantsAdvancedSellAmountOfTitlesLabel')}
                        type="text"
                        value={titleQuantity}
                        autoComplete="off"
                        onChange={this.handleTitleQuantityChanged}
                        maxLength={BROKER_STOCKS_ADVANCED_BUY_FIELDS_MAXLENGHT_LIMIT}
                    />
                </div>

                <div className="warrants-advanced-buy-step2__group-div">
                    <h2 className="warrants-advanced-buy-step2__subtitle">
                        <FormattedText value="broker-warrantsAdvancedBuyLimitPriceLabel" />
                    </h2>
                    <div className="warrants-advanced-buy-step2__text-input-wrapper warrants-advanced-buy-step2__text-input-wrapper--no-left">
                        <AmountInput
                            amount={limitPrice}
                            callback={this.onLimitedValueChanged}
                            max={BROKER_STOCKS_ADVANCED_BUY_FIELDS_AMOUNT_MAXLENGHT_LIMIT}
                            language={getLanguage()}
                            hideFocusZero
                        />
                    </div>
                </div>

                <div className="warrants-advanced-buy-step2__group-div">
                    <OKMessage
                        id="warrants-advanced-buy-step2-disclaimer"
                        type="informative"
                        visible={true}
                        extraClass="warrants-advanced-buy-step2__disclaimer"
                    >
                        <FormattedText value="broker-warrantsAdvancedBuyStep2Disclaimer" />
                    </OKMessage>
                </div>
            </div>
        );
    }
}

BrokerWarrantsAdvancedSellStep2.propTypes = {
	immBrokerWarrantsAdvancedSell: PropTypes.object.isRequired,
	immStocksContract: PropTypes.object.isRequired,
	stockContractChanged: PropTypes.func.isRequired,
    titleQuantityChanged: PropTypes.func.isRequired,
    limitedValueChanged: PropTypes.func.isRequired
};

module.exports.constructor = BrokerWarrantsAdvancedSellStep2;

module.exports.BrokerWarrantsAdvancedSellStep2 = connect(() => ({
}), {
    stockContractChanged: BrokerWarrantsAdvancedSellActions.stockContractChanged,
    titleQuantityChanged: BrokerWarrantsAdvancedSellActions.titleQuantityChanged,
    limitedValueChanged: BrokerWarrantsAdvancedSellActions.limitedValueChanged
})(BrokerWarrantsAdvancedSellStep2);